export default __webpack_public_path__ + "static/suiggle-97a3527d4d92e69cf886a06cff7be197.svg";